export default "__VITE_ASSET__1c6499f9__"